import logo from "../../assets/logos/Logo.svg";
import logout from "../../assets/icons/log-out.svg";
import { useUserContext } from "../../contexts/userContext";
import { useNavigate } from "react-router-dom";
import { useLogoutModal } from "../../contexts/logoutModalContext";
import francais from "../../assets/icons/france.png";
import anglais from "../../assets/icons/anglais.png";
import { useTranslation } from "react-i18next";
import { useNavStore } from "../../stores/components/nav";

const Header = () => {
  //Hooks
  const { openLogoutModal } = useLogoutModal();
  const { typeRole, lastname, firstname } = useUserContext();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { isMobileNavOpen, setMobileNavOpen } = useNavStore();

  const initials = `${firstname?.[0] ?? ""}${lastname?.[0] ?? ""}`.toUpperCase();

  return (
    <header className="z-50 flex h-16 w-full shrink-0 items-center justify-between border-b border-slate-200 bg-white/90 px-3 backdrop-blur sm:px-4 lg:px-6">
      <div className="flex min-w-0 items-center gap-2">
        {/* Ouverture du menu sur mobile, la barre latérale étant masquée */}
        <button
          type="button"
          onClick={() => setMobileNavOpen(!isMobileNavOpen)}
          aria-label="Ouvrir le menu"
          aria-expanded={isMobileNavOpen}
          className="inline-flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-xl border border-slate-200 text-slate-600 transition-colors hover:bg-slate-50 focus-visible:ring-2 focus-visible:ring-indigo-200 focus-visible:outline-none md:hidden"
        >
          <svg
            aria-hidden="true"
            className="size-5"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>

        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label="Retour"
          className="inline-flex shrink-0 cursor-pointer items-center justify-center rounded-xl border border-transparent px-1.5 py-1 transition-colors hover:border-indigo-100 hover:bg-indigo-50 focus-visible:ring-2 focus-visible:ring-indigo-200 focus-visible:outline-none"
        >
          <img src={logo} alt="" aria-hidden="true" className="h-8" />
        </button>
      </div>

      <div className="flex min-w-0 items-center gap-2 sm:gap-3">
        {typeRole === "Customer" ? (
          <div className="flex items-center gap-1 rounded-full border border-slate-200 bg-slate-50 p-1">
            <button
              type="button"
              onClick={() => i18n.changeLanguage("fr")}
              aria-label="Français"
              className={`inline-flex size-8 cursor-pointer items-center justify-center rounded-full transition-colors ${
                i18n.language?.startsWith("fr")
                  ? "bg-white shadow-sm"
                  : "opacity-60 hover:opacity-100"
              }`}
            >
              <img src={francais} alt="" aria-hidden="true" className="size-5" />
            </button>
            <button
              type="button"
              onClick={() => i18n.changeLanguage("en")}
              aria-label="English"
              className={`inline-flex size-8 cursor-pointer items-center justify-center rounded-full transition-colors ${
                i18n.language?.startsWith("en")
                  ? "bg-white shadow-sm"
                  : "opacity-60 hover:opacity-100"
              }`}
            >
              <img src={anglais} alt="" aria-hidden="true" className="size-5" />
            </button>
          </div>
        ) : null}

        {typeRole === "Company" && (
          <div className="flex min-w-0 items-center gap-2.5 rounded-full border border-slate-200 bg-slate-50 py-1 pr-3 pl-1">
            <span
              aria-hidden="true"
              className="inline-flex size-8 shrink-0 items-center justify-center rounded-full bg-dca-blue font-Nunito text-xs font-bold text-white"
            >
              {initials}
            </span>
            <p className="hidden truncate font-Nunito text-sm font-semibold text-slate-700 sm:block sm:max-w-48">
              {firstname} {lastname}
            </p>
          </div>
        )}

        <button
          type="button"
          onClick={openLogoutModal}
          aria-label="Déconnexion"
          title="Déconnexion"
          className="inline-flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-500 transition-colors hover:border-red-200 hover:bg-red-50 focus-visible:ring-2 focus-visible:ring-red-200 focus-visible:outline-none"
        >
          <img src={logout} alt="" aria-hidden="true" className="size-5" />
        </button>
      </div>
    </header>
  );
};

export default Header;
